import React from 'react';
import { Box, Button } from '@mui/material';
import { downloadFile, createCsv } from 'helpers';

export function DownloadCSVButton({headers, content, fileName, children}) {
  const exportList = (e) => {
    const data = createCsv(content, headers);
    e.preventDefault();
    downloadFile({
      data,
      fileName,
      fileType: 'text/csv'
    });
  };

  return (
    <Button
      color="primary"
      onClick={exportList}
      size="medium"
      variant="contained"
    >
      {children}
    </Button>
  );
}
